module.exports = __webpack_public_path__ + "static/media/Amanda_the_fisher_girl.da566b03.pdf";